'use strict';

module.exports = function(a, b, msg) {
  return '\u001b['+ a + 'm' + msg + '\u001b[' + b + 'm';
};



//////////////////
// WEBPACK FOOTER
// ./~/ansi-wrap/index.js
// module id = 322
// module chunks = 0